import { managedFarmPageInfo } from '../../constants/pageInfo/pageInfo.constant';

interface IOpenSmsWithManagedFarmInfo {
  fieldOwnerPhoneNumber: string;
  fieldAddress: string;
  fieldMeasurement: string;
  taskStatus: string;
  taskType: string;
  equipment: string;
  cropType: string;
  taskSchedule: string;
  checkpoint: string;
}

const makeSmsBody = (managedFarmInfo: IOpenSmsWithManagedFarmInfo): string => {
  const serviceUrl = process.env.REACT_APP_CLIENT_URL;

  const body = `플루바 마켓 - 대행반장에서 작업 정보를 보냈어요

[필지정보]
- 주소: ${managedFarmInfo.fieldAddress ?? ''}
- 평수: ${managedFarmInfo.fieldMeasurement ?? ''}평
- 작업 상태: ${managedFarmInfo.taskStatus ?? ''}

[작업 정보]
- 작업종류: ${managedFarmInfo.taskType ?? ''}
- 사용장비: ${managedFarmInfo.equipment ?? ''}
- 작물 종류: ${managedFarmInfo.cropType ?? ''}
- 예상 작업 기간: ${managedFarmInfo.taskSchedule ?? ''}

[전달할 사항]
- 전달할 사항 : ${managedFarmInfo.checkpoint ?? ''}
 
[플루바 마켓 - 대행반장]
${serviceUrl}${managedFarmPageInfo.entryPage.path}`;

  return body;
};

export const openSmsWithmanagedFarmInfo = (managedFarmInfo: IOpenSmsWithManagedFarmInfo) => {
  if (managedFarmInfo.fieldOwnerPhoneNumber) {
    const smsBody = makeSmsBody(managedFarmInfo);
    const smsLink = `sms:${managedFarmInfo.fieldOwnerPhoneNumber}?&body=${encodeURIComponent(smsBody)}`;
    window.location.href = smsLink;
  }
};
